import React from 'react'

import ReactDom from 'react-dom'

window.React = React

window.ReactDom = ReactDom

export { React, ReactDom }
